import type { IEndpointTokenAuthentication } from '@deity-io/di-data-flows';
import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IAuthorizationProps {
  isEditable: boolean;
  authentication?: Partial<IEndpointTokenAuthentication>;
  parent?: Partial<IEndpointTokenAuthentication>;
  onChange: (key: string[], value: any | null, set?: boolean) => void;
}

const TokenAuthentication: FC<IAuthorizationProps> = ({ isEditable, authentication, parent, onChange }) => (
  <>
    <Input
      label={
        !authentication?.clientToken && parent?.clientToken ? `${parent?.clientToken} (inherited)` : 'Client token'
      }
      type="text"
      name="client-token"
      id="client-token"
      value={(authentication as IEndpointTokenAuthentication)?.clientToken}
      onChange={e => onChange(['authentication', 'clientToken'], e?.target?.value, e?.target?.value?.trim() !== '')}
      placeholder="{variables.TOKEN_NAME}"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
    <Input
      label={!authentication?.authToken ? `***** (inherited)` : 'Authorization token'}
      type="password"
      name="authorization-token"
      id="authorization-token"
      value={(authentication as IEndpointTokenAuthentication)?.authToken}
      onChange={e => onChange(['authentication', 'authToken'], e?.target?.value, e?.target?.value?.trim() !== '')}
      placeholder="{variables.TOKEN_NAME}"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
  </>
);

export default TokenAuthentication;
